import { Table, TableBody, TableContainer, Typography } from "@mui/material";

import useParentLoaderData from "../../../../../../hooks/useParentLoaderData";
import useFetchTabData from "../../hooks/useFetchTabData";
import { useOperationHoursPermissions } from "../../hooks/useOperationHoursPermissions";
import useProviderHoursEditor from "../../hooks/useProviderHoursEditor";
import LoadingIndicator from "../fields/LoadingIndicator";

import ProviderHoursRow from "./ProviderHoursRow";
import ProviderHoursTableHead from "./ProviderHoursTableHead";

export default function ProviderHoursTable() {
  const { id } = useParentLoaderData(2);
  const { days, loading, refreshTimings } = useFetchTabData({ id });
  const {canViewHoursOfOperation} = useOperationHoursPermissions();

  const editor = useProviderHoursEditor({
    providerId: id,
    refreshTimings,
  });

  if(!canViewHoursOfOperation){
    return (
    <div className="h-full w-full">
      <Typography className="text-center text-[14px]">Nothing to show</Typography>
    </div>)
  }

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="h-full min-h-0 overflow-auto [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <TableContainer>
        <Table sx={{ tableLayout: "fixed" }}>
          <ProviderHoursTableHead />

          <TableBody>
            {days.map((row, index) => (
              <ProviderHoursRow
                key={row.day}
                row={row}
                index={index}
                editor={editor}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
